import styled from 'styled-components';

export const WidthRef = styled.div`
  width: 100%;
`;

export const List = styled.ul<{ $columns: number }>`
  display: grid;
  grid-template-columns: ${({ $columns }) =>
    `repeat(${$columns}, minmax(0, 1fr))`};

  list-style: none;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const ListItem = styled.li<{ $columns: number }>`
  border-right: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  &:nth-child(${({ $columns }) => $columns}n) {
    border-right: none;
  }

  &:nth-child(-${({ $columns }) => $columns}n) {
    border-bottom: none;
  }
`;

export const PremiumBannerContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
`;
